<template>
  <div
    tabindex="0"
    class="dropdown"
    :class="bodyClass"
    @keydown.up.prevent="activate"
    @keydown.down.prevent="activate"
    @keydown.enter.prevent="deactivate"
    @blur.prevent="deactivate"
    @keyup.esc.prevent="deactivate"
  >
    <div
      class="dropdown-toggle d-flex align-items-center"
      @mousedown.prevent="toggle"
    >
      <div v-if="value">{{ value }}</div>
      <div v-else>이름</div>
    </div>
    <ul class="dropdown-menu flex-wrap" v-show="activation">
      <li
        :key="option"
        v-for="option in options"
        class="option"
        :class="{ active: value && option === value }"
        @click="select(option)"
      >
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["options", "value", "bodyClass"],
  data() {
    return {
      activation: false
    };
  },
  watch: {
    activation() {
      if (!this.activation) {
        return;
      }

      this.$el.focus();
    }
  },
  methods: {
    toggle() {
      this.activation = !this.activation;
    },
    activate() {
      this.activation = true;
    },
    deactivate() {
      this.activation = false;
    },
    select(option) {
      if (this.value === option) {
        this.$emit("input", null);
      } else {
        this.$emit("input", option);
      }
      this.activation = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  min-width: 100px;
}

.dropdown:focus {
  outline-width: 0;
}

.dropdown-toggle {
  cursor: pointer;
  &::after {
    position: absolute;
    right: 0;
  }
}

.dropdown-menu {
  display: flex;
  padding: 10px;
  width: 220px;
}

.option {
  text-align: center;
  cursor: pointer;
  height: 20px;
  width: 20px;
  margin: 4px;
  border-radius: 10px;
  &.active {
    background-color: #b10101;
    color: #fff;
  }
  &:hover {
    background-color: #ededed;
  }
}
</style>
